export default __webpack_public_path__ + "static/media/8.9.81df1be2.mp3";